import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { CollectionFilterTypes } from '../../../config/constants';
import { changeFilterType } from '../../../redux/ducks/collections';

class CollectionFilterSwitcher extends Component {
  handleSwitch = (e) => {
    this.props.onChangeFilter(e.target.value);
  };

  render() {
    return (
      <div className="field is-horizontal" style={{ marginRight: '2rem' }}>
        <div className="field-label">
          <label
            htmlFor="collection-filter-type"
            className="label has-text-grey is-small"
            style={{ whiteSpace: 'nowrap' }}
          >
            Show:{' '}
          </label>
        </div>
        <div className="field-body">
          <div className="control">
            <div className="select is-rounded is-small">
              <select value={this.props.filterType} onChange={this.handleSwitch}>
                <option value={CollectionFilterTypes.ALL}>All</option>
                <option value={CollectionFilterTypes.IN_COLL}>In Collection</option>
                <option value={CollectionFilterTypes.NOT_IN_COLL}>Not In Collection</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CollectionFilterSwitcher.propTypes = {
  filterType: PropTypes.oneOf(_.keys(CollectionFilterTypes)).isRequired,
  onChangeFilter: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    filterType: state.collections.filterType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeFilter: (filter) => {
      dispatch(changeFilterType(filter));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionFilterSwitcher);



// WEBPACK FOOTER //
// ./src/components/pages/collections/CollectionFilterSwitcher.jsx